<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <BaseForm
      ref="form"
      :action="
        () => {
          return handleSubmit(submit);
        }
      "
      v-slot="formProps"
    >
      <div>
        <BaseFormCheckbox
          label="review assets"
          v-model="formData.reviewAssets"
          :disabled="formProps.isPending"
        />
        <span v-if="formProps.isResolved" key="resolved" class="text-green-600">Updated</span
        ><span v-if="formProps.isRejected" key="rejected" class="text-red-600">Failed</span>
      </div>
    </BaseForm>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'TaskReview',
  props: {
    task: {
      type: Object,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        reviewAssets: this.task.reviewAssets,
      },
    };
  },

  watch: {
    'task.reviewAssets': {
      handler(newReviewAssets) {
        this.formData.reviewAssets = newReviewAssets;
      },
    },
    'formData.reviewAssets': {
      handler() {
        this.$refs.form.handleSubmit();
      },
    },
  },
  methods: {
    async submit() {
      try {
        await this.$store.dispatch({
          type: 'ui/projectTasks/update',
          projectId: this.project.uuid,
          taskId: this.task.uuid,
          formData: this.formData,
        });

        this.$emit('task:updated');
      } catch (error) {
        // should handle 244 errors
      }
    },
  },
};
</script>
